import { Stack } from "@mui/system";
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import {
  setDefinitionModalSourceForMissingCrossNegatives,
  setIsDefinitionModalOpenForMissingCrossNegatives,
  setIsOpenModalOfOtherNonNegativeAdgroups,
  setOtherNonNegativeAdgroupsForMissingCrossNegatives,
  setSelectedRowsForMissingCrossNegatives,
  setSelectedSearchTermForMissingCrossNegatives,
} from "../../../../../../../../../features/searchTermTabSlice";
import { selectUserData } from "../../../../../../../../../features/userSlice";
import { CheckPermissions } from "../../../../../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { useSearchParams } from "react-router-dom";
import STMissingCrossNegativesFilterItems from "./STMissingCrossNegativesFilterItems";
import NegativeDefinitionModal from "./NegativeDefinitionModal";
import OtherNonNegativesAdgroupsModal from "./OtherNonNegativesAdgroupsModal";

const icons = [
  {
    label: "Negative",
    src: "/Ncross.svg",
    coloredSrc: "/NcrossColored.svg",
    alt: "Negative cross",
    tooltip: "Set as Negative",
    dataTracker: "550",
  },
];

function STMissingCrossNegativesFilterCard() {
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const [searchParams, setSearchParams] = useSearchParams();

  const hasCreateSearchTermTabPermission = CheckPermissions(
    response?.data?.products?.paid_traffic,
    "plan_campaign_ppc",
    "create_st_control"
  );

  const {
    stMissingCrossNegatives,
    selectedSearchTermForMissingCrossNegatives,
    selectedRowsForMissingCrossNegatives,
    isDefinitionModalOpenForMissingCrossNegatives,
    isOpenModalOfOtherNonNegativeAdgroups,
  } = useSelector((state: any) => state.searchTermTab);

  //--- Function to handle close of Other Non-Negative Adgroups Dialog
  const handleCloseTheOtherKeywordDialog = () => {
    dispatch(setOtherNonNegativeAdgroupsForMissingCrossNegatives([])); // Clear other Non-Negative Adgroups data
    dispatch(setIsOpenModalOfOtherNonNegativeAdgroups(false)); // Close the modal
  };

  //-- Function to handle close Negative Definition Modal
  const handleCloseDefinitionModal = () => {
    dispatch(setIsDefinitionModalOpenForMissingCrossNegatives(false)); // Close the modal
    dispatch(setDefinitionModalSourceForMissingCrossNegatives("")); // Clear source (headerIcon or saveButton)
  };

  const clearSelectedSearchTerm = () => {
    dispatch(setSelectedSearchTermForMissingCrossNegatives(""));
  };

  const searchOptions = useMemo(() => {
    const set = new Set<string>();
    (stMissingCrossNegatives || []).forEach((r: any) => {
      if (typeof r?.search_term === "string") set.add(r.search_term.trim());
    });
    return Array.from(set); // ["shoes", "hats", ...]
  }, [stMissingCrossNegatives]);

  const handleClick = () => {
    dispatch(setIsDefinitionModalOpenForMissingCrossNegatives(true));
    dispatch(
      setSelectedRowsForMissingCrossNegatives(
        selectedRowsForMissingCrossNegatives
      )
    );
    dispatch(setDefinitionModalSourceForMissingCrossNegatives("headerIcon"));
  };

  const hasSelection = selectedRowsForMissingCrossNegatives.length > 0;

  //-- this hold search params in url
  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    dispatch(
      setSelectedSearchTermForMissingCrossNegatives(searchParams.get("search"))
    );
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Paper sx={{ padding: "8px 16px", marginTop: "8px", boxShadow: "none" }}>
        <Stack
          flexDirection={"row"}
          justifyContent={"start"}
          gap={2}
          // sx={{ padding: "16px 16px 0px 16px" }}
        >
          {/* <Autocomplete
            fullWidth
            disablePortal
            data-tracker="547"
            sx={{ width: "390px" }}
            options={searchOptions}
            value={selectedSearchTermForMissingCrossNegatives || null} // string or null
            onChange={(_, newValue: string | null) => {
              dispatch(
                setSelectedSearchTermForMissingCrossNegatives(newValue ?? "")
              );
              setSearchParams((prevParams) => {
                const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
                if (newValue) {
                  updatedParams.search = newValue; // Set new value
                  updatedParams.page = "0";
                } else {
                  delete updatedParams.search; // Remove from URL if cleared
                }
                return updatedParams;
              });
            }}
            getOptionLabel={(opt) => opt || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Term"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
                color="secondary"
              />
            )}
            size="small"
          /> */}

          <Autocomplete
            fullWidth
            disablePortal
            freeSolo
            data-tracker="547"
            sx={{ width: "390px" }}
            options={searchOptions}
            value={selectedSearchTermForMissingCrossNegatives || ""}
            onChange={(_, newValue: string | null) => {
              dispatch(
                setSelectedSearchTermForMissingCrossNegatives(newValue ?? "")
              );
              setSearchParams((prevParams) => {
                const updatedParams = Object.fromEntries(prevParams);
                if (newValue) {
                  updatedParams.search = newValue;
                  updatedParams.page = "0";
                } else {
                  delete updatedParams.search;
                }

                return updatedParams;
              });
            }}
            getOptionLabel={(opt) => opt || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Term"
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
                color="secondary"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();

                    const inputValue = (
                      e.target as HTMLInputElement
                    ).value.trim();
                    if (!inputValue) return;

                    // dispatch
                    dispatch(
                      setSelectedSearchTermForMissingCrossNegatives(inputValue)
                    );

                    // update URL params
                    setSearchParams((prevParams) => {
                      const updatedParams = Object.fromEntries(prevParams);
                      updatedParams.search = inputValue;
                      updatedParams.page = "0";
                      return updatedParams;
                    });

                    // close dropdown
                    (e.target as HTMLInputElement).blur();
                  }
                }}
              />
            )}
            size="small"
          />

          <Stack
            flexDirection={"row"}
            justifyContent={"space-between"}
            sx={{ width: "100%" }}
          >
            <STMissingCrossNegativesFilterItems
              clearSelectedSearchTerm={clearSelectedSearchTerm}
            />
            {/* --- Bulk Actions Header --- */}
            <Stack gap={0.5}>
              {/* Row for Set As icons */}
              <Stack
                flexDirection="row"
                gap={1}
                justifyContent="space-between"
                alignItems="center"
              >
                <Stack direction="row" alignItems="center" gap={1}>
                  {/* Label */}
                  <Typography variant="body1">Set As:</Typography>

                  {icons.map(
                    ({ label, src, coloredSrc, alt, tooltip, dataTracker }) => {
                      const isDisabled =
                        !hasSelection || !hasCreateSearchTermTabPermission;

                      const iconSrc = hasSelection ? coloredSrc : src;

                      return (
                        <span key={label}>
                          <Tooltip
                            title={!isDisabled ? tooltip : ""}
                            arrow
                            disableHoverListener={isDisabled}
                          >
                            <span>
                              <IconButton
                                data-tracker={dataTracker}
                                size="small"
                                disabled={isDisabled}
                                onClick={handleClick}
                              >
                                <img
                                  src={iconSrc}
                                  alt={alt}
                                  width={hasSelection ? 24 : 32}
                                  height={hasSelection ? 24 : 32}
                                  // style={{
                                  //   filter: !isDisabled
                                  //     ? activeFilter
                                  //     : inactiveFilter,
                                  // }}
                                />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </span>
                      );
                    }
                  )}
                </Stack>
              </Stack>

              {/* Message BELOW */}
              <Typography variant="body2" color="text.secondary">
                * To perform bulk actions, select at least one row.
              </Typography>
            </Stack>
          </Stack>

          {/* Dialog for Other Keywords */}
          <OtherNonNegativesAdgroupsModal
            open={isOpenModalOfOtherNonNegativeAdgroups}
            onClose={handleCloseTheOtherKeywordDialog}
          />
          <NegativeDefinitionModal
            open={isDefinitionModalOpenForMissingCrossNegatives}
            onClose={handleCloseDefinitionModal}
          />
        </Stack>
      </Paper>
    </>
  );
}
export default STMissingCrossNegativesFilterCard;
